import { useState } from 'react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import Navbar from '@/components/Navbar/Navbar';
import { Sidebar } from '@/components/Sidebar/Sidebar';
import PgaHealthBanner from '@/components/PgaHealthBanner';
import LoadingSpinner from '@/components/LoadingSpinner';
import { PgaHealthProvider } from '@/context/PgaHealthContext';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) {
      return;
    }

    if (!context.auth.isAuthenticated) {
      return redirect({ to: '/login' });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { auth } = Route.useRouteContext();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (auth.loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <LoadingSpinner text="Validando sessão..." />
      </div>
    );
  }

  return (
    <PgaHealthProvider>
      <div className="min-h-screen">
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        <div className="flex min-h-screen min-w-0 flex-col overflow-x-clip md:ml-72">
          <Navbar
            sidebarOpen={sidebarOpen}
            onToggleSidebar={() => setSidebarOpen((open) => !open)}
          />
          <main className="min-h-0 flex-1 overflow-auto bg-[#F5F5F5] p-6 max-md:p-4">
            <PgaHealthBanner />
            <Outlet />
          </main>
        </div>
      </div>
    </PgaHealthProvider>
  );
}
